/**
 * ehr#666 (Chase 10-30): a progress note's length is never picked for the clinician. A new note
 * starts with no Length pressed and Duration blank; picking a session type doesn't press one
 * either. The only length a note starts with is the one its appointment or session was booked for
 * (a Calendar appointment, a group or family session), which is the session's own, not a guess.
 * A saved note shows the length it was saved with, or none.
 */

/** A new note's length: the appointment's or session's own, else none (0). */
export function startLength(o: { noShow: boolean; booked?: number | null }): number {
  if (o.noShow) return 0;
  return typeof o.booked === 'number' && o.booked > 0 ? o.booked : 0;
}

/** A saved (or copied) note's length: the one it was saved with, else none (0). */
export function savedLength(session: { durationMin?: number | null } | undefined): number {
  const m = session?.durationMin;
  return typeof m === 'number' && m > 0 ? m : 0;
}
